/**
 * Implementation of the Home page.
 *
 * Copyright © Ircam Amplify 2024-2026
 */
import { fetchConsumptionDataBatch } from '@/api'
import GetStartedContainer from '@/components/GetStarted/GetStartedContainer'
import HomeAiMusicDetector from '@/components/HomePageModule/AiMusicDetector/HomeAiMusicDectector'
import HomeModuleError from '@/components/HomePageModule/HomeModuleError'
import HomeStereoToSpatial from '@/components/HomePageModule/StereoToSpatial/HomeStereoToSpatial'
import HorizontalProgressBar from '@/components/HorizontalProgressBar'
import { ModuleKey } from '@/components/ModuleConfig/ModuleInfo'
import { ModuleInfoList } from '@/components/ModuleConfig/ModuleInfoList'
import { logger } from '@/config/logger'
import { getUserState, useSelector } from '@/store'
import { TierType } from '@amplify3/duplo-back-end'
import { useEffect, useState } from 'react'
import './HomePage.css'

export const HomePage = () => {
  const { companyConsumption } = useSelector(getUserState)
  const [fetchError, setFetchError] = useState(false)

  useEffect(() => {
    fetchConsumptionDataBatch().catch((error) => {
      console.log('Error in HomePage:', error)
      setFetchError(true)
    })
  }, [])

  const strTier = companyConsumption?.value?.subscription_tier

  let userTier = TierType.Unknown
  try {
    userTier = strTier as TierType
  } catch (e) {
    logger.error(`Invalid subscription tier: ${e}`)
  }

  const showAiMusicDetector =
    companyConsumption?.value?.auth_services?.includes(
      ModuleInfoList[ModuleKey.AiMusicDetector].serviceName
    )

  const showStereoToSpatial =
    companyConsumption?.value?.auth_services?.includes(
      ModuleInfoList[ModuleKey.StereoToSpatial].serviceName
    )

  return (
    <div className="homePage page">
      {fetchError ? (
        <HomeModuleError handleBack={() => window.location.reload()} />
      ) : !userTier || !companyConsumption?.value?.auth_services ? (
        <HorizontalProgressBar />
      ) : (
        <div>
          <div
            className={
              showAiMusicDetector && showStereoToSpatial
                ? 'start-basics-container--two'
                : 'start-basics-container--one'
            }
          >
            {showAiMusicDetector && (
              <HomeAiMusicDetector
                id="home-page-module-ai-music-detector"
                tier={userTier}
              />
            )}

            {showStereoToSpatial && (
              <HomeStereoToSpatial id="home-page-module-stero-to-spatial" />
            )}
          </div>

          <h2>Everything for your API integration</h2>
          <GetStartedContainer></GetStartedContainer>
        </div>
      )}
    </div>
  )
}
